const addParameterToUrl = (url, key, value) => {
  if (!url || !key) {
    return undefined
  }
  //url pulito
  if (url.indexOf("?") === -1) {
    return url + `?${key}=${value}`
  }
  return url + `&${key}=${value}`
}

const getUrlParameterValue = (name, url = undefined) => {

  const urlParams = new URLSearchParams(url && url.chatAt(0) === "?" ? url : window.location.search);
  if (urlParams.has(name)) {
    return urlParams.get(name)
  } else {
    return undefined
  }
}

module.exports = {
  addParameterToUrl, getUrlParameterValue
}